<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <create-form :on_submit="create" :form_data="form_data" :form_meta_data="form_meta_data"></create-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import $ from 'jquery';
import mainContent from '@/components/main-content.vue';
import CreateForm from './components/form';
import { merchantType } from '@/constants/merchantType';
import { i18n } from '@/plugins/i18n';
import { stakeholdersService } from '@/common/api.service';
import IranSheba from 'iran-sheba';

export default {
    components: {
        mainContent,
        CreateForm,
    },
    data() {
        return {
            merchantType: merchantType,
            form_data: {
                signature_holder: {
                    first_name_fa: '',
                    first_name_en: '',
                    last_name_fa: '',
                    last_name_en: '',
                    father_name_fa: '',
                    father_name_en: '',
                    birth_date: '',
                    national_code: '',
                },
                merchant_type:              null,
                telephone_number:           '',
                cellphone_number:           '',
                first_name_fa:              '',
                first_name_en:              '',
                last_name_fa:               '',
                last_name_en:               '',
                father_name_fa:             '',
                father_name_en:             '',
                gender:                     '',
                birth_date:                 '',
                national_code:              '',
                birth_crtfct_number:        '',
                birth_crtfct_serial:        '',
                birth_crtfct_series_letter: '',
                birth_crtfct_series_number: '',
                com_name_fa:                '',
                com_name_en:                '',
                register_date:              '',
                register_number:            '',
                national_legal_code:        '',
                email_address:              '',
                sheba_numbers:              [],
                is_editable:                true,
            },
            form_meta_data: {
                submit_btn_progress: false,
                submit_btn_text: i18n.t('stakeholders.btn.add'),
                invalid_sheba_numbers: [],
            },
        };
    },
    methods: {
        create() {
            let form = $('#submit_form');

            form.validate({
                rules: {
                    sheba_number_1: {
                        required: true,
                    },

                    merchant_type: {
                        required: true,
                    },
                    telephone_number: {
                        required: true,
                    },
                    cellphone_number: {
                        required: true,
                    },

                    first_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    first_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    last_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    last_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    father_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    father_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    gender: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    birth_date: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    national_code: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    birth_crtfct_number: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    birth_crtfct_serial: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    birth_crtfct_series_letter: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },
                    birth_crtfct_series_number: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.REAL;
                        },
                    },

                    com_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    com_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    register_date: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    register_number: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    national_legal_code: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },

                    signature_holder_first_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_first_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_last_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_last_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_father_name_fa: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_father_name_en: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_birth_date: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                    signature_holder_national_code: {
                        required: () => {
                            return this.form_data.merchant_type == merchantType.LEGAL;
                        },
                    },
                }
            });

            this.form_meta_data.invalid_sheba_numbers = [];
            let valid_sheba_numbers = [];

            for (let i = 0; i < this.form_data.sheba_numbers.length; ++i) {
                let value = this.form_data.sheba_numbers[i];

                // filter empty sheba
                if (value == '') {
                    continue;
                }
                valid_sheba_numbers.push(value);

                let sheba = 'IR' + value.split('-').join('');

                if (!IranSheba.isValid(sheba)) {
                    this.form_meta_data.invalid_sheba_numbers.push(i);
                }
            }

            if (this.form_meta_data.invalid_sheba_numbers.length) {
                return;
            }

            if (!form.valid()) {
                return;
            }
            
            this.form_meta_data.submit_btn_progress = true;

            let params = {
                sheba_numbers:              valid_sheba_numbers,
                merchant_type:              this.form_data.merchant_type,
                telephone_number:           this.form_data.telephone_number,
                cellphone_number:           this.form_data.cellphone_number,
                first_name_fa:              this.form_data.first_name_fa,
                first_name_en:              this.form_data.first_name_en,
                last_name_fa:               this.form_data.last_name_fa,
                last_name_en:               this.form_data.last_name_en,
                father_name_fa:             this.form_data.father_name_fa,
                father_name_en:             this.form_data.father_name_en,
                gender:                     this.form_data.gender,
                birth_date:                 this.form_data.birth_date,
                national_code:              this.form_data.national_code,
                birth_crtfct_number:        this.form_data.birth_crtfct_number,
                birth_crtfct_serial:        this.form_data.birth_crtfct_serial,
                birth_crtfct_series_letter: this.form_data.birth_crtfct_series_letter,
                birth_crtfct_series_number: this.form_data.birth_crtfct_series_number,
                com_name_fa:                this.form_data.com_name_fa,
                com_name_en:                this.form_data.com_name_en,
                register_date:              this.form_data.register_date,
                register_number:            this.form_data.register_number,
                national_legal_code:        this.form_data.national_legal_code,
                email_address:              this.form_data.email_address,

                signature_holder_first_name_fa:     this.form_data.signature_holder.first_name_fa,
                signature_holder_first_name_en:     this.form_data.signature_holder.first_name_en,
                signature_holder_last_name_fa:      this.form_data.signature_holder.last_name_fa,
                signature_holder_last_name_en:      this.form_data.signature_holder.last_name_en,
                signature_holder_father_name_fa:    this.form_data.signature_holder.father_name_fa,
                signature_holder_father_name_en:    this.form_data.signature_holder.father_name_en,
                signature_holder_birth_date:        this.form_data.signature_holder.birth_date,
                signature_holder_national_code:     this.form_data.signature_holder.national_code,
            };

            stakeholdersService.create(params).then((response) => {
                this.$router.push('/stakeholders');
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }
                this.showMsg(form, 'danger', response.data.message);
                window.scrollTo({top: 0, behavior: 'smooth'});
            })
            .finally(() => {
                this.form_meta_data.submit_btn_progress = false;
            });
        },
    }
}
</script>
